var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form__item checkbox-container" }, [
    _c("input", {
      class: { error: _vm.showError },
      attrs: { id: _vm.checkboxId, type: "checkbox", name: _vm.checkboxName },
      domProps: { checked: _vm.checked },
      on: {
        click: function($event) {
          return _vm.onClick($event.target.checked)
        }
      }
    }),
    _c("label", { attrs: { for: _vm.checkboxName } }, [
      _c(
        "strong",
        {
          staticClass: "mr-05",
          attrs: { "data-test": "checkbox-label-" + _vm.checkboxName }
        },
        [_vm._v(" " + _vm._s(_vm.label) + " ")]
      ),
      _c(
        "span",
        { attrs: { "data-test": "checkbox-helper-" + _vm.checkboxName } },
        [_vm._v(" " + _vm._s(_vm.helperText) + " ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }